import { DqlQuery, Query } from '../field';

export class OutgoingSms {

  readonly id: Query.OrderField;
  readonly deliveryTime: Query.OrderField;
  readonly messageId: Query.OrderField;

  constructor(prefix?: string) {
    prefix = prefix ? prefix : '';
    this.id = new DqlQuery.OrderField(prefix + 'id');
    this.deliveryTime = new DqlQuery.OrderField(prefix + 'delivery_time');
    this.messageId = new DqlQuery.OrderField(prefix + 'message_id');
  }

}
